var btnFloat = {
  "btnFloat": {
    "opacity": "0.8",
    "WebkitAnimationName": "floatin",
    "animationName": "floatin",
    "WebkitAnimationDuration": "0.25S",
    "animationDuration": "0.25S",
    "WebkitAnimationTimingFunction": "ease-in-out",
    "animationTimingFunction": "ease-in-out",
    "&:hover": {
      "opacity": "0.9"
    }
  },
  "keyframesFloatin": {
    "@keyframes floatin": {
      "0%": {
        "opacity": "0"
      },
      "100%": {
        "opacity": "0.8"
      }
    }
  }
};

export default btnFloat;
